import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom/client';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import DotPopup from '../../MapPopups/DotPopup/DotPopup.jsx';
import { changeLayerVisibility, flyTo } from '../../../utils/mapbox-utils.js';
import {
  $sezDots,
  $sezPolygons,
  changePopupDataEv,
} from '../../../models/investProModel/index.js';
import { $activeProjects } from '../../../models/activeFiltersModel/index.js';

const onClusterClick = (e) => {
  const features = window.map.queryRenderedFeatures(e.point, {
    layers: ['invest_pro_cluster_sez_dots_layer'],
  });
  const clusterId = features[0].properties.cluster_id;
  window.map
    .getSource(`invest_pro_sez_dots_source`)
    .getClusterExpansionZoom(clusterId, (err, zoom) => {
      if (err) return;

      window.map.easeTo({
        center: features[0].geometry.coordinates,
        zoom,
      });
    });
};

const onDotClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();
  flyTo(coordinates, 12);
  changePopupDataEv(feature);

  // if (window.dotPopups && window.dotPopups.length > 0) {
  //   if (
  //     window.dotPopups.find((item) => item.options.id === feature.properties.id)
  //   )
  //     return;
  // }
  //
  // const newPopup = new mapboxgl.Popup({
  //   closeOnClick: false,
  //   closeButton: false,
  //   id: feature.properties.id,
  // })
  //   .setLngLat(coordinates)
  //   .setHTML('')
  //   .addTo(window.map);
  //
  // if (!window.dotPopups) {
  //   window.dotPopups = [newPopup];
  // } else {
  //   if (window.dotPopups.length === 1) {
  //     const first = window.dotPopups.shift();
  //     first.remove();
  //   }
  //   window.dotPopups.push(newPopup);
  // }
  //
  // const popups = Array.from(
  //   document.getElementsByClassName('mapboxgl-popup-content')
  // );
  // popups.forEach((popup) => {
  //   if (popup.childNodes.length === 0)
  //     ReactDOM.createRoot(popup).render(
  //       <DotPopup feature={feature} instance={newPopup} />
  //     );
  // });
};

function Sezlayer() {
  const dots = useUnit($sezDots);
  const polygons = useUnit($sezPolygons);
  const mapLoaded = useUnit($mapLoaded);
  const activeProjects = useUnit($activeProjects);

  const createLayer = (update) => {
    const dotsData = {
      type: 'FeatureCollection',
      features: dots,
    };
    const polygonsData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map.getSource(`invest_pro_sez_dots_source`).setData(dotsData);
      window.map
        .getSource(`invest_pro_sez_polygons_source`)
        .setData(polygonsData);
    } else {
      if (!window.map.getSource(`invest_pro_sez_dots_source`)) {
        window.map.addSource(`invest_pro_sez_dots_source`, {
          type: 'geojson',
          data: dotsData,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50,
          generateId: true,
        });

        window.map.addSource('invest_pro_sez_polygons_source', {
          type: 'geojson',
          data: polygonsData,
        });
      }

      if (!window.map.getLayer(`invest_pro_dots_sez_dots_layer`)) {
        window.map.addLayer({
          id: 'invest_pro_sez_polygon_layer',
          type: 'fill',
          source: 'invest_pro_sez_polygons_source',
          paint: {
            'fill-color': '#6A0DAD',
            'fill-outline-color': '#000000',
          },
        });

        // FIXME Cluster layer
        window.map.addLayer({
          id: `invest_pro_cluster_sez_dots_layer`,
          type: 'circle',
          source: `invest_pro_sez_dots_source`,
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#6A0DAD',
            'circle-stroke-color': 'black',
            'circle-stroke-width': 3,
            'circle-radius': 7,
          },
        });

        window.map.addLayer({
          id: `invest_pro_dots_bg_sez_dots_layer`,
          type: 'circle',
          source: `invest_pro_sez_dots_source`,
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': 'white',
            'circle-radius': 12,
          },
        });

        // FIXME Unclustered dots layer
        window.map.addLayer({
          id: `invest_pro_dots_sez_dots_layer`,
          type: 'symbol',
          source: `invest_pro_sez_dots_source`,
          filter: ['!', ['has', 'point_count']],
          layout: {
            'icon-image': 'sez',
            'icon-size': 1,
            'icon-allow-overlap': true,
          },
        });

        // FIXME Labels layer
        window.map.addLayer({
          id: `invest_pro_sez_dots_labels_layer`,
          type: 'symbol',
          source: `invest_pro_sez_dots_source`,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-size': 12,
          },
          paint: {
            'text-color': 'white',
          },
        });

        window.map.on(
          'click',
          `invest_pro_cluster_sez_dots_layer`,
          onClusterClick
        );
        window.map.on('click', `invest_pro_dots_sez_dots_layer`, onDotClick);

        window.map.on('mouseenter', 'invest_pro_cluster_sez_dots_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });
        window.map.on('mouseenter', 'invest_pro_dots_sez_dots_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });

        window.map.on('mouseleave', 'invest_pro_dots_sez_dots_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });
        window.map.on('mouseleave', 'invest_pro_cluster_sez_dots_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });
        changeLayerVisibility('invest_pro_dots_bg_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_cluster_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_dots_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_sez_dots_labels_layer', false);
        changeLayerVisibility('invest_pro_sez_polygon_layer', false);
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && dots) {
      if (window.map.getLayer(`invest_pro_dots_sez_dots_layer`)) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, dots]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('invest_pro_dots_sez_dots_layer')) {
      if (activeProjects.includes('sez')) {
        changeLayerVisibility('invest_pro_dots_bg_sez_dots_layer', true);
        changeLayerVisibility('invest_pro_cluster_sez_dots_layer', true);
        changeLayerVisibility('invest_pro_dots_sez_dots_layer', true);
        changeLayerVisibility('invest_pro_sez_dots_labels_layer', true);
        changeLayerVisibility('invest_pro_sez_polygon_layer', true);
      } else {
        changeLayerVisibility('invest_pro_dots_bg_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_cluster_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_dots_sez_dots_layer', false);
        changeLayerVisibility('invest_pro_sez_dots_labels_layer', false);
        changeLayerVisibility('invest_pro_sez_polygon_layer', false);
      }
    }
  }, [activeProjects]);

  return null;
}

export default Sezlayer;
